import { c as _c } from "react/compiler-runtime";
import { Stack, Typography, Divider, Box } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import { BulletItem } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/bulletItem';
import { NumericBulletSection } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/numericBulletSection';
import type { BackupVault } from '@/data/vaults/backupVault';
import { getDocsUrl } from '@/docs/docsUrls';
import { KmsCopyablePolicy } from './kmsCopyablePolicy';
import { KmsEditKeyPolicyButton } from './kmsEditKeyPolicyButton';
import { BottomDialog } from '../dialogs/bottomDialog';
import { FormTextField } from '../form/formTextField';
import { getCloudFieldConfig } from '../form/validation/cloudFieldValidation';
import { PanelWrapper } from '../panels/panelWrapper';
import { ReadMoreLink } from '../shared/readMoreLink';
const KmsKeyDescription = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="body1" component="span">Set the KMS key to encrypt snapshots with. You’re responsible for securing the key from unauthorized access and deletion. Without this key, snapshots can’t be retrieved from the vault.{" "}<ReadMoreLink href={getDocsUrl("vaultSelfManagedKeys")} /></Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const kmsKeyArnConfig = getCloudFieldConfig(Provider.Aws, 'kmsKeyArn');
export const KMSKeyEditorPanel = t0 => {
  const $ = _c(30);
  const {
    open,
    onClose,
    data,
    setData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <KmsKeyDescription />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] !== onClose) {
    t2 = {
      title: "Set KMS Key",
      subtitle: t1,
      fullWidthSubtitle: false,
      onClose
    };
    t3 = {
      primaryButton: {
        text: "Done",
        "data-testid": "done-button",
        onClick: onClose
      },
      secondaryButton: {
        text: "Cancel",
        "data-testid": "cancel-button",
        onClick: onClose
      }
    };
    $[1] = onClose;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      padding: "40px min(100px,6vw)",
      width: "100%",
      height: "auto"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    t6 = {
      gap: "40px"
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  const t7 = data.vaultAttributes.aws?.encryptionKey ?? "";
  let t8;
  if ($[7] !== data || $[8] !== setData) {
    t8 = event => {
      setData({
        ...data,
        vaultAttributes: {
          ...data.vaultAttributes,
          aws: {
            ...data.vaultAttributes.aws,
            encryptionKey: event.target.value
          }
        }
      });
    };
    $[7] = data;
    $[8] = setData;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <NumericBulletSection bulletNumber={1} title="Set key details"><BulletItem leftContent={<FormTextField title="KMS key ARN" placeholder={kmsKeyArnConfig.placeholder} value={t7} onChange={t8} validation={kmsKeyArnConfig.validation} />} /></NumericBulletSection>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = data.vaultAttributes.aws?.encryptionKey;
  let t11;
  if ($[13] !== t10) {
    t11 = <KmsEditKeyPolicyButton kmsKey={t10} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== data.vaultAttributes.cloudProvider) {
    t12 = <KmsCopyablePolicy cloudProvider={data.vaultAttributes.cloudProvider} />;
    $[15] = data.vaultAttributes.cloudProvider;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <NumericBulletSection bulletNumber={2} title="Add policy in AWS"><BulletItem title="Review and add this policy in your AWS account. Afterward, come back to this tab to finish the connection." leftContent={t11} rightContent={t12} /></NumericBulletSection>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t9) {
    t14 = <Box sx={t4}><Stack divider={t5} sx={t6}>{t9}{t13}</Stack></Box>;
    $[20] = t13;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t2 || $[25] !== t3) {
    t15 = <PanelWrapper header={t2} footer={t3}>{t14}</PanelWrapper>;
    $[23] = t14;
    $[24] = t2;
    $[25] = t3;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== open || $[28] !== t15) {
    t16 = <BottomDialog open={open}>{t15}</BottomDialog>;
    $[27] = open;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};